// UBB-322: Loop's loop_widget app block renders NOTHING outside the product template (its
// Liquid reads the page `product` context), so sections/product-on-cms-page.liquid marks
// itself with data-loop-widget-fetch="<product url>". We fetch the real PDP, lift the app
// block's server-rendered widget markup + scripts (container/skeleton divs, the
// window.LOOP_WIDGET data script, and Loop's extension loop_widget.js — so no app-version
// URLs are hardcoded here), and mount them above the buy block. loop-widget.js's
// MutationObserver then brand-styles the injected widget exactly as on the PDP.
// ponytail: widget position is fixed above product-info-buy — the theme-editor block order
// can't move it on CMS pages; revisit only if a merchant actually asks.
async function loopWidgetCms() {
  const section = document.querySelector(
    'section[id^="MainProduct-"][data-loop-widget-fetch]'
  );
  if (!section) return;
  // If Loop ever fixes the app block on non-product templates, defer to it.
  if (section.querySelector('.loop-widget-container')) return;

  const mount = section.querySelector('.product-info__purchase');
  if (!mount) return;

  let doc;
  try {
    const res = await fetch(section.dataset.loopWidgetFetch);
    if (!res.ok) return;
    doc = new DOMParser().parseFromString(await res.text(), 'text/html');
  } catch {
    return;
  }

  const block = doc.querySelector(
    '[id^="shopify-block"][id*="loop_subscriptions_loop_widget"]'
  );
  if (!block) return;

  // Bring Loop's own extension stylesheet along (Shopify injects it with the app block on the
  // PDP). NOT the theme asset loop_widget.css — that's the UBB-235 quickview copy, which
  // overrides the brand radio/check-circle swap.
  const cssLink = doc.querySelector(
    'link[rel="stylesheet"][href*="/extensions/"][href*="loop"]'
  );
  if (cssLink && !document.querySelector(`link[href="${cssLink.href}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssLink.href;
    document.head.appendChild(link);
  }

  const holder = document.createElement('div');
  holder.className = 'loop-widget-cms';
  mount.insertBefore(holder, mount.querySelector('.product-info__buy'));

  // <script> tags injected via innerHTML never execute — pull them out and recreate them.
  const scripts = [...block.querySelectorAll('script')];
  scripts.forEach((s) => s.remove());
  holder.innerHTML = block.innerHTML;
  scripts.forEach((s) => {
    const tag = document.createElement('script');
    if (s.src) tag.src = s.src;
    else tag.textContent = s.textContent;
    holder.appendChild(tag);
  });
}

export default loopWidgetCms;
